module.exports = __webpack_public_path__ + "img/icon6.fd36568e.png";